import React, { ChangeEvent, ReactElement } from "react";
import { Button, Col, FormCheck, FormControl, Row } from "react-bootstrap";
import {
	ProjectTask,
	ProjectTaskChecklist,
	ProjectTaskChecklistItem,
	useProjects,
} from ".";
import { Editable } from "../ui";

interface IProps {
	item: ProjectTaskChecklistItem;
	checklist: ProjectTaskChecklist;
	task: ProjectTask;
}

export const ProjectTaskChecklistItemElement = (
	props: IProps,
): ReactElement => {
	const projectContext = useProjects();
	const item = props.item;

	const handleTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
		event.stopPropagation();
		item.title = event.target.value;
	};

	const handleCheckChange = (event: ChangeEvent<HTMLInputElement>) => {
		event.stopPropagation();
		item.completed = !item.completed;

		projectContext.saveUpdateProjectTaskChecklistItem!(
			props.task,
			props.checklist,
			item,
		);
	};

	const handleDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();

		projectContext.deleteProjectTaskChecklistItem!(
			props.task,
			props.checklist,
			item,
		);
	};

	return (
		<Row className="project-task-checklist-item">
			<Col sm={1}>
				<FormCheck
					custom
					defaultChecked={item.completed ? item.completed : false}
					onChange={handleCheckChange}
					label=""
					type="checkbox"
					id={`checklist-item-${item.id}`}
				/>
			</Col>
			<Col>
				<Editable
					shownComponent={
						<span
							className={`item-title ${
								item.completed ? "item-completed" : ""
							}`}
						>
							{item.title}

							<Button
								variant="light"
								className="float-right delete-item-button"
								onClick={handleDelete}
							>
								Delete
							</Button>
						</span>
					}
					editComponent={
						<FormControl
							defaultValue={item.title ? item.title : ""}
							onChange={handleTitleChange}
						/>
					}
					onFinishedEditing={() => {
						projectContext.saveUpdateProjectTaskChecklistItem!(
							props.task,
							props.checklist,
							item,
						);
					}}
				/>
			</Col>
		</Row>
	);
};
